import reduceReducers from 'reduce-reducers';
import defaultEditorState from 'components/pages/livefeed/defaultstate';
import slideCrudReducer from './slideCrudReducer'
import editorReducer from './editorReducer'
import steerpathMapReducer from './steerpathMapReducer'
import livefeedOptionsReducer from './livefeedOptionsReducer'
import historyReducer from './historyReducer'

const initialState = defaultEditorState;

const livefeededitor = reduceReducers(
    initialState,
    editorReducer,
    slideCrudReducer,
    steerpathMapReducer,
    livefeedOptionsReducer,
    historyReducer
)
export default livefeededitor


// WEBPACK FOOTER //
// ./src/reducers/livefeededitor/index.js